import Button from "@mui/material/Button"
import { useSetAtom } from "jotai"
import { createEdgesDialogAtom } from "@features/builder/CreateEdges/createEdgesDialogAtom"
import useNodeLock from "@features/builder/hooks/useNodeLock"
import { FormHelperText } from "@mui/material"
import { isLocked, isMyLock } from "@features/builder/hooks/socketIOHooks"
import { EdgeDirection } from "@features/builder/CreateEdges/types"

export const CreateEdgesOpenButton = ({
  nodeId,
  sourceNodeIds,
  label = "Create edges",
  initialDirection = "Parents",
  disabled,
}: {
  nodeId: string
  sourceNodeIds: string[]
  label?: string
  initialDirection?: EdgeDirection
  disabled: boolean
}) => {
  const nodeLock = useNodeLock({ nodeId: nodeId })

  const setCreateEdgesDialog = useSetAtom(createEdgesDialogAtom)

  const handleParentToAnotherNodeCopy = () => {
    setCreateEdgesDialog({
      open: true,
      sourceNodeIds,
      initialDirection,
    })
  }

  return (
    <>
      <Button
        variant="contained"
        onClick={handleParentToAnotherNodeCopy}
        sx={{ width: "max-content" }}
        disabled={disabled}
      >
        {label}
      </Button>
      {isMyLock(nodeLock) && (
        <FormHelperText>To edit edges you need to save all your changes</FormHelperText>
      )}
      {isLocked(nodeLock) && <FormHelperText>Node is locked, cant edit edges</FormHelperText>}
    </>
  )
}
